import { DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTopShipperReport extends Layout {
    excludabletextboxCategory: ExcludableTextbox;
    excludabletextboxShipper: ExcludableTextbox;
    sourceTopShipper: DataSource;
    switchCompareBetweenPeriods: Switch;
    switchIncludeFuelSurchargeinRevenue: Switch;
    switchIncludeRemainingOtherChargesinRevenue: Switch;
    switchPrintMonthlyTotals: Switch;
    textboxDateType: Textbox;
    textboxNumberShipper: Textbox;
    textboxPeriodOne: Textbox;
    textboxPeriodTwo: Textbox;
    textboxSortBy: Textbox;
}
